import { useSuspenseQuery } from '@tanstack/react-query'

import { GetUltimosAtendimentosService } from '@/features/atendimento/shared/http'
import { atendimentoKeys } from '@/utils/atendimento-query-keys'

export const useSuspenseUltimosAtendimentos = () => {
  return useSuspenseQuery({
    queryKey: atendimentoKeys.ultimosAtendimentos(),
    queryFn: async () => new GetUltimosAtendimentosService().execute(),
    staleTime: 1000 * 60 * 10,
  })
}
